module.exports = __webpack_public_path__ + "static/media/rocket.9c73498c.gif";